jQuery(document).ready(function($) {
  'use strict';
  if ($('#analyticsid').length > 0 && $('[name=\'Action:Submit\']').length > 0) {
    $('[name=\'Action:Submit\']').on('click', function(e) {
      $('#analyticsid').val(window.ipcsasn);
    });
  }
});